export default "__VITE_ASSET__NEgFL8qi__"